import { gql } from '__generated__';

export default gql(`
  mutation AddMessage($input: AddMessageInput!) {
    addMessage(input: $input) {
      id
    }
  }
`);
